import { useFormatUserDate } from "../core/useFormatUserDate";
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Data, PropertyChange, diffItems } from "./ActivityHistory";
import "./ActivityItem.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ActivityItem(_ref) {
  let {
    item,
    showTarget
  } = _ref;
  const formatDateTime = useFormatUserDate({
    withTime: true
  });
  const [detailed, setDetailed] = useState(false);
  if (item.prevUser === null) {
    return /*#__PURE__*/_jsx("div", {
      className: "ActivityItem",
      children: /*#__PURE__*/_jsxs("div", {
        className: "ActivityItem__row ActivityItem__row--disabled",
        children: [/*#__PURE__*/_jsx("div", {
          className: "ActivityItem__row-item",
          children: "Created"
        }), showTarget && /*#__PURE__*/_jsx("div", {
          className: "ActivityItem__row-item",
          children: /*#__PURE__*/_jsx("b", {
            children: /*#__PURE__*/_jsx(Link, {
              to: `/users/edit/${encodeURIComponent(item.user.email)}`,
              children: item.user.email
            })
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "ActivityItem__row-item",
          children: /*#__PURE__*/_jsx("b", {
            children: /*#__PURE__*/_jsx(Link, {
              to: `/users/edit/${encodeURIComponent(item.author)}`,
              children: item.author
            })
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "ActivityItem__row-item",
          children: formatDateTime(new Date(item.timestamp))
        })]
      })
    });
  }
  const changes = item.prevUser ? diffItems(item.prevUser, item.user) : undefined;
  if (changes === undefined || changes.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: "ActivityItem",
    "data-sentry-component": "ActivityItem",
    "data-sentry-source-file": "ActivityItem.tsx",
    children: [/*#__PURE__*/_jsxs("div", {
      onClick: () => setDetailed(x => !x),
      className: "ActivityItem__row",
      children: [/*#__PURE__*/_jsx("div", {
        className: "ActivityItem__toggle",
        children: detailed ? '-' : '+'
      }), /*#__PURE__*/_jsx("div", {
        className: "ActivityItem__row-item",
        children: "Edited"
      }), showTarget && /*#__PURE__*/_jsx("div", {
        className: "ActivityItem__row-item",
        children: /*#__PURE__*/_jsx("b", {
          children: /*#__PURE__*/_jsx(Link, {
            to: `/users/edit/${encodeURIComponent(item.user.email)}`,
            children: item.user.email
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "ActivityItem__row-item",
        children: /*#__PURE__*/_jsx("b", {
          children: /*#__PURE__*/_jsx(Link, {
            to: `/users/edit/${encodeURIComponent(item.author)}`,
            "data-sentry-element": "Link",
            "data-sentry-source-file": "ActivityItem.tsx",
            "data-sentry-element": "Link",
            children: item.author
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "ActivityItem__row-item",
        children: formatDateTime(new Date(item.timestamp))
      })]
    }), detailed && /*#__PURE__*/_jsx("div", {
      className: "ActivityItem__diff",
      children: /*#__PURE__*/_jsxs("table", {
        className: "ActivityItem__diff-table",
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              style: {
                width: '30px'
              }
            }), /*#__PURE__*/_jsx("th", {
              style: {
                width: '150px'
              },
              children: "Field"
            }), /*#__PURE__*/_jsx("th", {
              children: "Before"
            }), /*#__PURE__*/_jsx("th", {
              children: "After"
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: changes.map(_ref2 => {
            let {
              kind,
              lhs,
              rhs,
              path
            } = _ref2;
            return /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx(PropertyChange, {
                  kind: kind
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("div", {
                  style: {
                    display: 'flex'
                  },
                  children: path.join('.')
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx(Data, {
                  data: lhs
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx(Data, {
                  data: rhs
                })
              })]
            }, path.join('.'));
          })
        })]
      })
    })]
  });
}